<template>
  <div id="corsiscelti">


    <!--{{corsi}}-->
<template>
  <v-card>
    <v-card-title>
      <b>{{$t('corsi.selezionati')}}</b>
      <v-spacer></v-spacer>
      
    </v-card-title>
   
    <v-data-table :id="elencocorsi"
      :item-key="name"
      :headers="headers"
      :items="corsi"
      :search="search"
      :items-per-page="5"
      :footer-props="{
      showFirstLastPage: true,
      firstIcon: false,
      lastIcon: false,
      prevIcon: 'navigate_before',
      nextIcon: 'navigate_next'
    }"
    >
    
    <template slot="no-data">
   <v-alert :value="true" icon="warning">
     {{$t('corsi.nessunaSelezione')}}
   </v-alert>
 </template>
    <template v-slot:item.icona="props">
      
       
       
    <!--<button class="btn btn-primary btn-link" @click="cancellacorso(props.item)"></button>-->
  <i class="material-icons md-36" @click="cancellacorso(props.item)" style="cursor: pointer;">delete_forever</i>

  
      </template>
    
    </v-data-table>
  
    
  </v-card>
</template>
   
        
    </div>

</template>


<script>
  export default {
     props: {dati:[],
            tabella: String
            },
    data () {
      return {
        name:'',
        search: '',
        headers: [
          
          {
            text: 'Corso',
            align: 'start',
            value: 'sigla',
          },
          { text: 'semestre', value: 'semestre' },
          { text: '', value: 'icona' }
        ],
        
        
      }
    },

computed : {

corsi() {
      return this.$store.state.corsiscelti[this.tabella];
    },
},


    methods : {
      cancellacorso : function(dati){
          
          // conferma della cancellazione
          this.$confirm(
        {
          message: this.$t('corsi.cancellazione',{corso: dati.sigla}),
          button: {
            no: this.$t('no'),
            yes: this.$t('si')
          },
          /**
          * Callback Function
          * @param {Boolean} confirm 
          */
          callback: confirm => {
            if (confirm) {
              const corsodel = this.corsi.findIndex( h => h.corso === dati.corso);
          
               this.corsi.splice(corsodel, 1);
            }
          }
          });
          //
          
          
          
        }

    }
  }
</script>

<style>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>


